import { create, match } from "../fable-library.3.7.12/RegExp.js";
import { head, isEmpty, empty, tail } from "../fable-library.3.7.12/List.js";
import { map, delay, toList } from "../fable-library.3.7.12/Seq.js";
import { Union, Record } from "../fable-library.3.7.12/Types.js";
import { uint16_type, option_type, array_type, bool_type, tuple_type, unit_type, lambda_type, list_type, class_type, union_type, record_type, string_type } from "../fable-library.3.7.12/Reflection.js";
import { join, printf, toText } from "../fable-library.3.7.12/String.js";
import { FSharpResult$2 } from "../fable-library.3.7.12/Choice.js";
import { parse } from "../fable-library.3.7.12/Int32.js";

export function Common_$007CRegex$007C_$007C(pattern, input) {
    const m = match(create(pattern), input);
    if (m != null) {
        return tail(toList(delay(() => map((g) => (g || ""), m))));
    }
    else {
        return void 0;
    }
}

export class Common_Name extends Record {
    constructor(given, family) {
        super();
        this.given = given;
        this.family = family;
    }
}

export function Common_Name$reflection() {
    return record_type("Webbler.Models.Api.Common.Name", [], Common_Name, () => [["given", string_type], ["family", string_type]]);
}

export function Common_Name_create(first, last) {
    return new Common_Name(first, last);
}

export function Common_Name_display_4140EA02(name) {
    return toText(printf("%s %s"))(name.given)(name.family);
}

export function Common_Name_sanitize_4140EA02(name) {
    return new Common_Name(name.given.trim(), name.family.trim());
}

export function Common_Name_get_given_() {
    return [(m) => m.given, (v) => ((m_1) => (new Common_Name(v, m_1.family)))];
}

export function Common_Name_get_family_() {
    return [(m) => m.family, (v) => ((m_1) => (new Common_Name(m_1.given, v)))];
}

export class Common_EmailAddress extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["EmailAddress"];
    }
    toString() {
        const x = this;
        return Common_EmailAddress_value_Z39D6D3C1(x);
    }
}

export function Common_EmailAddress$reflection() {
    return union_type("Webbler.Models.Api.Common.EmailAddress", [], Common_EmailAddress, () => [[["Item", string_type]]]);
}

export function Common_EmailAddress_create_Z721C83C5(s) {
    const str = (s !== null) ? s.trim() : "";
    if (match(/^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/g, str) != null) {
        return new FSharpResult$2(0, new Common_EmailAddress(0, str));
    }
    else {
        return new FSharpResult$2(1, void 0);
    }
}

export function Common_EmailAddress_value_Z39D6D3C1(_arg1) {
    return _arg1.fields[0];
}

export class Security_UserViewModel$2 extends Record {
    constructor(id, email, name, roles, userData) {
        super();
        this.id = id;
        this.email = email;
        this.name = name;
        this.roles = roles;
        this.userData = userData;
    }
}

export function Security_UserViewModel$2$reflection(gen0, gen1) {
    return record_type("Webbler.Models.Api.Security.UserViewModel`2", [gen0, gen1], Security_UserViewModel$2, () => [["id", class_type("System.Guid")], ["email", string_type], ["name", Common_Name$reflection()], ["roles", list_type(gen0)], ["userData", gen1]]);
}

export function Security_UserViewModel$2_empty_1505(emptyUserData) {
    return new Security_UserViewModel$2("00000000-0000-0000-0000-000000000000", "", Common_Name_create("", ""), empty(), emptyUserData);
}

export function Security_UserViewModel$2_get_id_() {
    return [(m) => m.id, (v) => ((m_1) => (new Security_UserViewModel$2(v, m_1.email, m_1.name, m_1.roles, m_1.userData)))];
}

export function Security_UserViewModel$2_get_email_() {
    return [(m) => m.email, (v) => ((m_1) => (new Security_UserViewModel$2(m_1.id, v, m_1.name, m_1.roles, m_1.userData)))];
}

export function Security_UserViewModel$2_get_name_() {
    return [(m) => m.name, (v) => ((m_1) => (new Security_UserViewModel$2(m_1.id, m_1.email, v, m_1.roles, m_1.userData)))];
}

export function Security_UserViewModel$2_get_roles_() {
    return [(m) => m.roles, (v) => ((m_1) => (new Security_UserViewModel$2(m_1.id, m_1.email, m_1.name, v, m_1.userData)))];
}

export function Security_UserViewModel$2_get_userData_() {
    return [(m) => m.userData, (v) => ((m_1) => (new Security_UserViewModel$2(m_1.id, m_1.email, m_1.name, m_1.roles, v)))];
}

export class Security_UserInfoError extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["InvalidEmailAddress"];
    }
}

export function Security_UserInfoError$reflection() {
    return union_type("Webbler.Models.Api.Security.UserInfoError", [], Security_UserInfoError, () => [[]]);
}

export class Security_UserInfo$2 extends Record {
    constructor(id, email, name, roles, userData) {
        super();
        this.id = id;
        this.email = email;
        this.name = name;
        this.roles = roles;
        this.userData = userData;
    }
}

export function Security_UserInfo$2$reflection(gen0, gen1) {
    return record_type("Webbler.Models.Api.Security.UserInfo`2", [gen0, gen1], Security_UserInfo$2, () => [["id", class_type("System.Guid")], ["email", Common_EmailAddress$reflection()], ["name", Common_Name$reflection()], ["roles", list_type(gen0)], ["userData", gen1]]);
}

export function Security_UserInfo$2_get_id_() {
    return [(m) => m.id, (v) => ((m_1) => (new Security_UserInfo$2(v, m_1.email, m_1.name, m_1.roles, m_1.userData)))];
}

export function Security_UserInfo$2_get_email_() {
    return [(m) => m.email, (v) => ((m_1) => (new Security_UserInfo$2(m_1.id, v, m_1.name, m_1.roles, m_1.userData)))];
}

export function Security_UserInfo$2_get_name_() {
    return [(m) => m.name, (v) => ((m_1) => (new Security_UserInfo$2(m_1.id, m_1.email, v, m_1.roles, m_1.userData)))];
}

export function Security_UserInfo$2_get_roles_() {
    return [(m) => m.roles, (v) => ((m_1) => (new Security_UserInfo$2(m_1.id, m_1.email, m_1.name, v, m_1.userData)))];
}

export function Security_UserInfo$2_get_userData_() {
    return [(m) => m.userData, (v) => ((m_1) => (new Security_UserInfo$2(m_1.id, m_1.email, m_1.name, m_1.roles, v)))];
}

export function Security_UserInfo$2_fromViewModel_Z62CB2AC(viewModel) {
    const matchValue = Common_EmailAddress_create_Z721C83C5(viewModel.email);
    if (matchValue.tag === 0) {
        return new FSharpResult$2(0, new Security_UserInfo$2(viewModel.id, matchValue.fields[0], viewModel.name, viewModel.roles, viewModel.userData));
    }
    else {
        return new FSharpResult$2(1, new Security_UserInfoError(0));
    }
}

export function Security_UserInfo$2_toViewModel_Z3F1C2E28(userInfo) {
    return new Security_UserViewModel$2(userInfo.id, Common_EmailAddress_value_Z39D6D3C1(userInfo.email), userInfo.name, userInfo.roles, userInfo.userData);
}

export class Security_RegisterViewModel extends Record {
    constructor(email, password, givenName, familyName, roles) {
        super();
        this.email = email;
        this.password = password;
        this.givenName = givenName;
        this.familyName = familyName;
        this.roles = roles;
    }
}

export function Security_RegisterViewModel$reflection() {
    return record_type("Webbler.Models.Api.Security.RegisterViewModel", [], Security_RegisterViewModel, () => [["email", string_type], ["password", string_type], ["givenName", string_type], ["familyName", string_type], ["roles", list_type(string_type)]]);
}

export function Security_RegisterViewModel_get_empty() {
    return new Security_RegisterViewModel("", "", "", "", empty());
}

export class Security_LoginViewModel extends Record {
    constructor(email, password) {
        super();
        this.email = email;
        this.password = password;
    }
}

export function Security_LoginViewModel$reflection() {
    return record_type("Webbler.Models.Api.Security.LoginViewModel", [], Security_LoginViewModel, () => [["email", string_type], ["password", string_type]]);
}

export function Security_LoginViewModel_get_empty() {
    return new Security_LoginViewModel("", "");
}

export class Security_ResetPasswordViewModel extends Record {
    constructor(email, resetToken, newPassword, confirmPassword) {
        super();
        this.email = email;
        this.resetToken = resetToken;
        this.newPassword = newPassword;
        this.confirmPassword = confirmPassword;
    }
}

export function Security_ResetPasswordViewModel$reflection() {
    return record_type("Webbler.Models.Api.Security.ResetPasswordViewModel", [], Security_ResetPasswordViewModel, () => [["email", string_type], ["resetToken", string_type], ["newPassword", string_type], ["confirmPassword", string_type]]);
}

export function Security_ResetPasswordViewModel_get_empty() {
    return new Security_ResetPasswordViewModel("", "", "", "");
}

export class Security_ChangePasswordViewModel extends Record {
    constructor(currentPassword, newPassword) {
        super();
        this.currentPassword = currentPassword;
        this.newPassword = newPassword;
    }
}

export function Security_ChangePasswordViewModel$reflection() {
    return record_type("Webbler.Models.Api.Security.ChangePasswordViewModel", [], Security_ChangePasswordViewModel, () => [["currentPassword", string_type], ["newPassword", string_type]]);
}

export class Security_EmailChangeViewModel extends Record {
    constructor(currentEmail, newEmail, changeToken) {
        super();
        this.currentEmail = currentEmail;
        this.newEmail = newEmail;
        this.changeToken = changeToken;
    }
}

export function Security_EmailChangeViewModel$reflection() {
    return record_type("Webbler.Models.Api.Security.EmailChangeViewModel", [], Security_EmailChangeViewModel, () => [["currentEmail", string_type], ["newEmail", string_type], ["changeToken", string_type]]);
}

export function Security_EmailChangeViewModel_get_empty() {
    return new Security_EmailChangeViewModel("", "", "");
}

export class Security_LoginResponse extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["AccessToken", "ForceChangePasswordChallenge"];
    }
}

export function Security_LoginResponse$reflection() {
    return union_type("Webbler.Models.Api.Security.LoginResponse", [], Security_LoginResponse, () => [[["jwtToken", string_type]], [["jwtToken", string_type]]]);
}

export class Security_AuthErrorMessage extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["GenericAuthError", "InvalidEmailError", "IdentityErrors", "InvalidCredentials", "ExpiredPassword", "LockedOut", "LockSelfError", "MissingUser", "NoPermission", "PasswordMismatch", "MissingClaims"];
    }
}

export function Security_AuthErrorMessage$reflection() {
    return union_type("Webbler.Models.Api.Security.AuthErrorMessage", [], Security_AuthErrorMessage, () => [[], [["Item", string_type]], [["Item", list_type(string_type)]], [], [], [], [], [], [], [], []]);
}

export function Security_AuthErrorMessage_get_describe() {
    return (_arg1) => ((_arg1.tag === 1) ? toText(printf("%s is not a valid e-mail address"))(_arg1.fields[0]) : ((_arg1.tag === 2) ? join(", ", _arg1.fields[0]) : ((_arg1.tag === 3) ? "Invalid login credentials. Please ensure you have entered the correct email address and password" : ((_arg1.tag === 4) ? "Your password has expired, please request a new one" : ((_arg1.tag === 5) ? "Unable to log in, user has been locked out. Please contact a site admin for assistance" : ((_arg1.tag === 6) ? "Unable to lock yourself out. Please select another user" : ((_arg1.tag === 7) ? "Unable to find user" : ((_arg1.tag === 8) ? "You do not have permission to perform this action" : ((_arg1.tag === 9) ? "Passwords do not match" : ((_arg1.tag === 10) ? "Missing information for user" : "An error occurred"))))))))));
}

export class Security_PublicAuthApi extends Record {
    constructor(login, refreshToken, register, requestPasswordResetTokenEmail, resetPasswordWithToken, requestEmailChangeTokenEmail, emailChangeWithToken) {
        super();
        this.login = login;
        this.refreshToken = refreshToken;
        this.register = register;
        this.requestPasswordResetTokenEmail = requestPasswordResetTokenEmail;
        this.resetPasswordWithToken = resetPasswordWithToken;
        this.requestEmailChangeTokenEmail = requestEmailChangeTokenEmail;
        this.emailChangeWithToken = emailChangeWithToken;
    }
}

export function Security_PublicAuthApi$reflection() {
    return record_type("Webbler.Models.Api.Security.PublicAuthApi", [], Security_PublicAuthApi, () => [["login", lambda_type(Security_LoginViewModel$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [Security_LoginResponse$reflection(), Security_AuthErrorMessage$reflection()], FSharpResult$2, () => [[["ResultValue", Security_LoginResponse$reflection()]], [["ErrorValue", Security_AuthErrorMessage$reflection()]]])]))], ["refreshToken", lambda_type(string_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [string_type, Security_AuthErrorMessage$reflection()], FSharpResult$2, () => [[["ResultValue", string_type]], [["ErrorValue", Security_AuthErrorMessage$reflection()]]])]))], ["register", lambda_type(Security_RegisterViewModel$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, Security_AuthErrorMessage$reflection()], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", Security_AuthErrorMessage$reflection()]]])]))], ["requestPasswordResetTokenEmail", lambda_type(string_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, Security_AuthErrorMessage$reflection()], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", Security_AuthErrorMessage$reflection()]]])]))], ["resetPasswordWithToken", lambda_type(Security_ResetPasswordViewModel$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, Security_AuthErrorMessage$reflection()], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", Security_AuthErrorMessage$reflection()]]])]))], ["requestEmailChangeTokenEmail", lambda_type(tuple_type(string_type, string_type), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, Security_AuthErrorMessage$reflection()], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", Security_AuthErrorMessage$reflection()]]])]))], ["emailChangeWithToken", lambda_type(Security_EmailChangeViewModel$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, Security_AuthErrorMessage$reflection()], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", Security_AuthErrorMessage$reflection()]]])]))]]);
}

export class Security_SecuredAuthApi$1 extends Record {
    constructor(logout, changeUserInfo, changePassword, getUserInfo) {
        super();
        this.logout = logout;
        this.changeUserInfo = changeUserInfo;
        this.changePassword = changePassword;
        this.getUserInfo = getUserInfo;
    }
}

export function Security_SecuredAuthApi$1$reflection(gen0) {
    return record_type("Webbler.Models.Api.Security.SecuredAuthApi`1", [gen0], Security_SecuredAuthApi$1, () => [["logout", lambda_type(unit_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, Security_AuthErrorMessage$reflection()], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", Security_AuthErrorMessage$reflection()]]])]))], ["changeUserInfo", lambda_type(gen0, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, Security_AuthErrorMessage$reflection()], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", Security_AuthErrorMessage$reflection()]]])]))], ["changePassword", lambda_type(Security_ChangePasswordViewModel$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, Security_AuthErrorMessage$reflection()], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", Security_AuthErrorMessage$reflection()]]])]))], ["getUserInfo", lambda_type(unit_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [gen0, Security_AuthErrorMessage$reflection()], FSharpResult$2, () => [[["ResultValue", gen0]], [["ErrorValue", Security_AuthErrorMessage$reflection()]]])]))]]);
}

export class Security_SecuredUserManagementApi$2 extends Record {
    constructor(createUser, editUser, changeUserLockoutStatus, deleteUser, getUsers, getCurrentUserInfo) {
        super();
        this.createUser = createUser;
        this.editUser = editUser;
        this.changeUserLockoutStatus = changeUserLockoutStatus;
        this.deleteUser = deleteUser;
        this.getUsers = getUsers;
        this.getCurrentUserInfo = getCurrentUserInfo;
    }
}

export function Security_SecuredUserManagementApi$2$reflection(gen0, gen1) {
    return record_type("Webbler.Models.Api.Security.SecuredUserManagementApi`2", [gen0, gen1], Security_SecuredUserManagementApi$2, () => [["createUser", lambda_type(gen1, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [gen0, Security_AuthErrorMessage$reflection()], FSharpResult$2, () => [[["ResultValue", gen0]], [["ErrorValue", Security_AuthErrorMessage$reflection()]]])]))], ["editUser", lambda_type(gen1, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, Security_AuthErrorMessage$reflection()], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", Security_AuthErrorMessage$reflection()]]])]))], ["changeUserLockoutStatus", lambda_type(tuple_type(gen1, bool_type), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, Security_AuthErrorMessage$reflection()], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", Security_AuthErrorMessage$reflection()]]])]))], ["deleteUser", lambda_type(gen1, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, Security_AuthErrorMessage$reflection()], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", Security_AuthErrorMessage$reflection()]]])]))], ["getUsers", lambda_type(unit_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [array_type(gen0), Security_AuthErrorMessage$reflection()], FSharpResult$2, () => [[["ResultValue", array_type(gen0)]], [["ErrorValue", Security_AuthErrorMessage$reflection()]]])]))], ["getCurrentUserInfo", lambda_type(unit_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [option_type(gen0), Security_AuthErrorMessage$reflection()], FSharpResult$2, () => [[["ResultValue", option_type(gen0)]], [["ErrorValue", Security_AuthErrorMessage$reflection()]]])]))]]);
}

export class Mqtt_MqttConfiguration extends Record {
    constructor(Host, Path, Port, User, Pwd, IsSecure) {
        super();
        this.Host = Host;
        this.Path = Path;
        this.Port = Port;
        this.User = User;
        this.Pwd = Pwd;
        this.IsSecure = IsSecure;
    }
}

export function Mqtt_MqttConfiguration$reflection() {
    return record_type("Webbler.Models.Api.Mqtt.MqttConfiguration", [], Mqtt_MqttConfiguration, () => [["Host", string_type], ["Path", string_type], ["Port", uint16_type], ["User", string_type], ["Pwd", string_type], ["IsSecure", bool_type]]);
}

export function Mqtt_fromConnectionString(_arg1) {
    let pattern_matching_result, hostname, path, port, pwd, uid;
    const activePatternResult14353 = Common_$007CRegex$007C_$007C("mqtt://(.*?):(.*?)@(.*?):(.*?)/(.*)", _arg1);
    if (activePatternResult14353 != null) {
        if (!isEmpty(activePatternResult14353)) {
            if (!isEmpty(tail(activePatternResult14353))) {
                if (!isEmpty(tail(tail(activePatternResult14353)))) {
                    if (!isEmpty(tail(tail(tail(activePatternResult14353))))) {
                        if (!isEmpty(tail(tail(tail(tail(activePatternResult14353)))))) {
                            if (isEmpty(tail(tail(tail(tail(tail(activePatternResult14353))))))) {
                                pattern_matching_result = 0;
                                hostname = head(tail(tail(activePatternResult14353)));
                                path = head(tail(tail(tail(tail(activePatternResult14353)))));
                                port = head(tail(tail(tail(activePatternResult14353))));
                                pwd = head(tail(activePatternResult14353));
                                uid = head(activePatternResult14353);
                            }
                            else {
                                pattern_matching_result = 1;
                            }
                        }
                        else {
                            pattern_matching_result = 1;
                        }
                    }
                    else {
                        pattern_matching_result = 1;
                    }
                }
                else {
                    pattern_matching_result = 1;
                }
            }
            else {
                pattern_matching_result = 1;
            }
        }
        else {
            pattern_matching_result = 1;
        }
    }
    else {
        pattern_matching_result = 1;
    }
    switch (pattern_matching_result) {
        case 0: {
            return new Mqtt_MqttConfiguration(hostname, path, parse(port, 511, true, 16), uid, pwd, false);
        }
        case 1: {
            let pattern_matching_result_1, hostname_1, path_1, port_1, pwd_1, uid_1;
            const activePatternResult14342 = Common_$007CRegex$007C_$007C("mqtts://(.*?):(.*?)@(.*?):(.*?)/(.*)", _arg1);
            if (activePatternResult14342 != null) {
                if (!isEmpty(activePatternResult14342)) {
                    if (!isEmpty(tail(activePatternResult14342))) {
                        if (!isEmpty(tail(tail(activePatternResult14342)))) {
                            if (!isEmpty(tail(tail(tail(activePatternResult14342))))) {
                                if (!isEmpty(tail(tail(tail(tail(activePatternResult14342)))))) {
                                    if (isEmpty(tail(tail(tail(tail(tail(activePatternResult14342))))))) {
                                        pattern_matching_result_1 = 0;
                                        hostname_1 = head(tail(tail(activePatternResult14342)));
                                        path_1 = head(tail(tail(tail(tail(activePatternResult14342)))));
                                        port_1 = head(tail(tail(tail(activePatternResult14342))));
                                        pwd_1 = head(tail(activePatternResult14342));
                                        uid_1 = head(activePatternResult14342);
                                    }
                                    else {
                                        pattern_matching_result_1 = 1;
                                    }
                                }
                                else {
                                    pattern_matching_result_1 = 1;
                                }
                            }
                            else {
                                pattern_matching_result_1 = 1;
                            }
                        }
                        else {
                            pattern_matching_result_1 = 1;
                        }
                    }
                    else {
                        pattern_matching_result_1 = 1;
                    }
                }
                else {
                    pattern_matching_result_1 = 1;
                }
            }
            else {
                pattern_matching_result_1 = 1;
            }
            switch (pattern_matching_result_1) {
                case 0: {
                    return new Mqtt_MqttConfiguration(hostname_1, path_1, parse(port_1, 511, true, 16), uid_1, pwd_1, true);
                }
                case 1: {
                    return new Mqtt_MqttConfiguration("localhost", "", 8080, "", "", false);
                }
            }
        }
    }
}

export function Mqtt_ofTopic(topic) {
    return Array.from(map((_arg1) => {
        if (_arg1 === ".") {
            return "/";
        }
        else {
            return _arg1;
        }
    }, topic.split(""))).join('');
}

export function Mqtt_userSub(topic, uid) {
    return toText(printf("nx.%O.%s"))(uid)(topic).toLocaleLowerCase();
}

export function Route_builder(typeName, methodName) {
    return toText(printf("/api/%s/%s"))(typeName)(methodName);
}

